import { useEffect, useMemo, useState } from 'react'
import { isClient } from '../../../../helpers'

export type SelectedFilter = { id: string; category: string }

const getInitialFilterState = (synchronizedParams?: string[]): SelectedFilter[] => {
  if (isClient) {
    const currentURL = new URL(window.location.href)
    const entries = currentURL.searchParams.entries()
    const result: SelectedFilter[] = []

    for (const [category, value] of entries) {
      if (synchronizedParams?.some((param) => param === category)) {
        value.split(',').forEach((id) => {
          result.push({ id, category })
        })
      }
    }
    return result
  }
  return []
}

export const useSearchFilters = (
  synchronizedParams?: string[]
): [SelectedFilter[], Record<string, string>, React.Dispatch<React.SetStateAction<SelectedFilter[]>>] => {
  const [searchParams, setSearchParams] = useState<SelectedFilter[]>(getInitialFilterState(synchronizedParams))

  const parsedFilters = useMemo(
    () =>
      searchParams.reduce((acc, { id, category }) => {
        if (id) {
          if (acc[category]) {
            acc[category] = `${acc[category]},${id}`
          } else {
            acc[category] = id
          }
        }

        return acc
      }, {} as Record<string, string>),
    [searchParams]
  )

  useEffect(() => {
    const currentURL = new URL(window.location.href)
    //* Delete synchronized params
    synchronizedParams?.forEach((param) => currentURL.searchParams.delete(param))

    Object.entries(parsedFilters).forEach(([category, ids]) => {
      if (ids) {
        currentURL.searchParams.set(category, ids)
      }
    })

    window.history.replaceState(null, '', currentURL)
  }, [parsedFilters])

  return [searchParams, parsedFilters, setSearchParams]
}
